import validate from 'containers/services/validateForm';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { DETAIL_JUGEMENT_ADD } from 'containers/data-structure';
import { PROCEDURE_NATURES } from 'containers/LawyerLegalProceedingsPage/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export const detailsConstraints = (details: Idetails) => {
  return {
    [DETAIL_JUGEMENT_ADD.PROCEDURE_NATURE_ID]: {
      presence: true,
    },
    [DETAIL_JUGEMENT_ADD.JURISDICTION_ID]: {
      presence: true,
    },
    [DETAIL_JUGEMENT_ADD.IS_INSURED_SUED]: {
      presence: !featureService.hasFeature(FEATURES.SUED_PARTY)
        ? details[DETAIL_JUGEMENT_ADD.PROCEDURE_NATURE_ID] ===
          PROCEDURE_NATURES.CORRECTIONAL
        : false,
    },
    [DETAIL_JUGEMENT_ADD.SUED_PARTIES]: {
      presence: featureService.hasFeature(FEATURES.SUED_PARTY)
        ? details[DETAIL_JUGEMENT_ADD.PROCEDURE_NATURE_ID] ===
          PROCEDURE_NATURES.CORRECTIONAL
        : false,
    },
    [DETAIL_JUGEMENT_ADD.PACKAGE_CONTINUATION]: {
      presence:
        details[DETAIL_JUGEMENT_ADD.PROCEDURE_NATURE_ID] ===
        PROCEDURE_NATURES.CORRECTIONAL,
    },
    [DETAIL_JUGEMENT_ADD.COURT_FILE]: {
      presence: true,
    },
    [DETAIL_JUGEMENT_ADD.HEARING_DATE]: {
      presence: true,
    },
  };
};

export const detailsValidator = (details: Idetails) => {
  return validate(details, detailsConstraints(details));
};
